export default {
  clientVersion: process.env.VUE_APP_VERSION || '1.0.0',
  authUrl: `${process.env.VUE_APP_BASE_URL}/${process.env.VUE_APP_AUTH_PATH}`,  
  hubUrl: `${process.env.VUE_APP_BASE_URL}/${process.env.VUE_APP_HUB_PATH}`
}
